import { RutterItemRuleLineKind } from '@treadinc/horizon-api-spec';

const I18N_PREFIX =
  'administration.integration.rutter.quick_books_online.item_rules.sections';

interface ItemRuleSectionDefinition {
  lineKind: RutterItemRuleLineKind;
  placeholderKey: string;
  titleKey: string;
}

export const ITEM_RULE_SECTIONS: ItemRuleSectionDefinition[] = [
  {
    lineKind: RutterItemRuleLineKind.FREIGHT,
    titleKey: `${I18N_PREFIX}.freight.title`,
    placeholderKey: `${I18N_PREFIX}.freight.placeholder`,
  },
  {
    lineKind: RutterItemRuleLineKind.MATERIAL,
    titleKey: `${I18N_PREFIX}.material.title`,
    placeholderKey: `${I18N_PREFIX}.material.placeholder`,
  },
  {
    lineKind: RutterItemRuleLineKind.ADD_ON,
    titleKey: `${I18N_PREFIX}.add_on.title`,
    placeholderKey: `${I18N_PREFIX}.add_on.placeholder`,
  },
];
